module.exports = __webpack_public_path__ + "static/media/dancing-sandwich.b532a1d6.gif";